import { darkColors, lightColors } from "../../theme/colors";
export var light = {
    handleBackground: lightColors.backgroundAlt,
    handleShadow: lightColors.textDisabled
};
export var dark = {
    handleBackground: darkColors.backgroundAlt,
    handleShadow: darkColors.textDisabled
};
